import PropTypes from "prop-types";
import { kloString } from "src/components/js/statics1";
import { keikkaString_html } from "src/pages/keikkaGrid/components/common";
import { useDarkModeData } from "src/context/DarkModeContext";
import { ReportContext, reportContext_defaultSettingsData } from "src/context/ReportContext";
import { useContext, useEffect, useState } from "react";
import { asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import { useUserData } from "src/context/userContext";
import { useGridData } from "src/context/GridContext/GridContext";

// eslint-disable-next-line no-unused-vars
export default function Report_ReportComponent_Keikka({ keikka, vehicle = null }) {
  const context = useContext(ReportContext);
  // const { settingsData } = useContext(ReportContext) || {};
  const { user, token } = useUserData();
  const { darkMode } = useDarkModeData();
  const { palkkiTypes } = useGridData() || {};
  const [sourceAsiakasNimi, setSourceAsiakasNimi] = useState(null);

  // Fallback to default settings if context is not available
  const settingsData = context?.settingsData || reportContext_defaultSettingsData;
  useEffect(() => {
    if (!keikka.isKeikka) return; // only keikka has sourceAsiakasId
    if (!settingsData.showSource) return; // only show source if settingsData.showSource is true
    if (sourceAsiakasNimi) return; // already fetched
    asiakas_fetch(user, keikka.sourceAsiakasId, token).then((a) =>
      setSourceAsiakasNimi(a.globalAsiakas.asiakasNimi)
    );
  }, [keikka.sourceAsiakasId, settingsData?.showSource]);

  if (!keikka) return null;
  if (!settingsData.showComments && keikka.isPalkki) return null;

  const currentPalkkiType = keikka.isPalkki
    ? palkkiTypes.find((p) => p.grid_palkkiTypeId === keikka.grid_palkkiTypeId)
    : null;

  // skip if palkkiType is not shown in report
  if (currentPalkkiType && currentPalkkiType.showInReport === false) return null;

  PalkkiKloString.propTypes = {
    keikka: PropTypes.object,
    palkkiType: PropTypes.object,
  };

  // Convert reportStyle string to a valid style object
  const parsedStyle = currentPalkkiType?.reportStyle
    ? reportStyleToObject(currentPalkkiType.reportStyle)
    : {};

  return (
    <div
      style={{
        display: "flex",
        paddingTop: keikka.isKeikka ? settingsData.rowSpacing : 0,
        transition: "0.3s all ease-in-out",
        alignItems: "flex-start",
        width: "100%",
      }}
      className="fixPrint">
      <PalkkiKloString keikka={keikka} palkkiType={currentPalkkiType} />
      <div style={{ flex: 1 }}>
        {keikka.isKeikka && settingsData.showSource && (
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "bold" }}>{sourceAsiakasNimi}</div>
            <div style={{ fontSize: "0.8em", color: "gray" }}>
              #{keikka.keikkaId}
              {keikka.foreignKey && `/${keikka.foreignKey}`}
            </div>
          </div>
        )}
        {keikka.isPalkki && (
          <div style={{ fontSize: "10px", color: "gray", lineHeight: 0.8 }}>
            {currentPalkkiType?.grid_palkkiType}
          </div>
        )}
        {keikka.isKeikka ? (
          <div
            style={{
              flex: 1,
              fontSize: settingsData.bodyFontSize,
              transition: "0.3s all ease-in-out",
              lineHeight: keikka.isPalkki ? 1 : 1.3,
              paddingLeft: keikka.isPalkki ? 4 : 0,
              ...parsedStyle,
            }}
            dangerouslySetInnerHTML={{
              __html: keikkaString_html(
                keikka,
                null,
                1,
                darkMode,
                settingsData.showSource ? "" : "<small>#{keikkaId} {foreignKey}</small>"
              ),
            }}
          />
        ) : (
          <div
            style={{
              fontSize: settingsData.bodyFontSize - 2,
              lineHeight: 1,
              paddingLeft: 4,
              // preserve line breaks in comments
              whiteSpace: "pre-wrap",
            }}>
            {keikka.keikkaComment
              .split(" ")
              .filter((word) => !word.startsWith("*"))
              .join(" ")}
          </div>
        )}
      </div>
    </div>
  );

  function PalkkiKloString({ keikka, palkkiType }) {
    return (
      <div
        style={{
          width: 60,
          fontSize: settingsData.bodyFontSize,
          lineHeight: 1.3,
          transition: "0.3s all ease-in-out",
        }}>
        <div>{(!palkkiType || palkkiType.showReportKlo) && kloString(keikka.timeStart)}</div>{" "}
      </div>
    );
  }
}

Report_ReportComponent_Keikka.propTypes = {
  keikka: PropTypes.object,
  vehicle: PropTypes.object,
};

// Utility function to parse reportStyle string into an object
function reportStyleToObject(styleString) {
  try {
    const styleObject = {};
    styleString
      .split(",")
      .map((rule) => rule.trim())
      .forEach((rule) => {
        const [key, value] = rule.split(":").map((item) => item.trim());
        if (key && value) {
          const camelCaseKey = key.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
          styleObject[camelCaseKey] = value.replace(/"/g, ""); // Remove quotes
        }
      });
    return styleObject;
  } catch (error) {
    console.error("Failed to parse reportStyle:", styleString, error);
    return {};
  }
}
